import axios from 'axios';
import API from "../config/API";
import siteSetting from "../config/env";
import { param } from 'jquery';

export const paymentService = {
    getTransactionFee,
    activationCode,
    subscriptionRetrieve,
    subscriptionCheckout,
    subscription,
    requestDemo,
    bookingPayment,
    bookingPaymentDane,
    paymentList,
    bankLink,
    getBank,
    deleteBankAccount,
    payoutList,
    payout,
    instantPayout,
    addTerminal,
    requestCardReader,
    fetchConnectionToken,
    cardReaderList,
    cardReaderDelete,
    paymentIntents,
    paymentIntentsCapture,
    subscriptionGet,
    updateTransactionFee,
    createLoginLink,
    cancelTerminalTransaction,
    checkCardAdded,
    paymentMethodAdd,
    cardRemove,
    cardMakePrimery,
    makeCustomerPrimaryCard,
    setUpIntent,
    createPaymentLink,
    checkPaymentLinkStatus,
    createKlarnaPaymentLink,
    createClearpayPaymentLink,
    sendPaymentLinkEmail
};

function activationCode(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA=="
    };
    return axios.post(API.PAYMENT_ACTIVATATION_CODE, params,{headers:headers})
}

function subscriptionCheckout(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        // Send the logged-in merchant's token (the v2 signup wizard creates + logs
        // in the account before the plan step). The BE uses it to pin the Stripe
        // Checkout to the merchant's own customer, so the card they enter is the
        // one the subscription + Billing/Marketing later read — no fragile
        // post-redirect re-link. Empty for public callers → BE mints a customer.
        'accessToken': localStorage.getItem('accessToken') || ''
    };
    return axios.post(API.PAYMENT_SUBSCRIPTION_CHECKOUT,params, {headers:headers})
}

function subscriptionRetrieve(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA=="
    };
    return axios.post(API.PAYMENT_SUBSCRIPTION_RETRIEVE,params, {headers:headers})
}

function subscription(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA=="
    };
    return axios.post(API.PAYMENT_SUBSCRIPTION,params, {headers:headers})
}

function requestDemo(params) {
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA=="
    };
    return axios.post(API.REQUEST_DEMO,params, {headers:headers})
}

function bookingPayment(params) {
    // Guests aren't logged in, so they pass their booking-scoped token
    // explicitly; everyone else uses the stored session.
    let accessToken = (params && params.accessToken) || localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };

    const body = { ...params };
    delete body.accessToken;
    // console.log("headers",headers);
    return axios.post(API.BOOKING_PAYMENT, body,{headers:headers})
}

function bookingPaymentDane(params) {
    let accessToken=localStorage.getItem('accessToken')
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    // console.log("headers",headers);
    return axios.post(API.BOOKING_PAYMENT_DONE, params,{headers:headers})
}

function makeCustomerPrimaryCard(params) {
    let accessToken=localStorage.getItem('accessToken')
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    // console.log("headers",headers);
    return axios.post(API.MAKE_CUSTOMER_DEFAULT_CARD, params,{headers:headers})
}




function paymentList(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.PAYMENT_LIST, params,{headers:headers})
}


function bankLink(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.BANK_LINK, params,{headers:headers})
}

function getBank(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.BANK_DETAIL, params,{headers:headers})
}

function deleteBankAccount(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.BANK_ACCOUNT_DELETE, params,{headers:headers})
}

function payoutList(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.PAYOUT_LIST, params,{headers:headers})
}

function payout(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.PAYOUT, params,{headers:headers})
}

function instantPayout(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    console.log("headers instant =====>",headers,params);   
    return axios.post(API.INSTANT_PAYOUT, params,{headers:headers})
}

function addTerminal(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.ADD_TERMINAL, params,{headers:headers})
}

function requestCardReader(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.REQUEST_CARD_READER, params,{headers:headers})
}

function fetchConnectionToken(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.FETCH_CONNECTION_TOKEN, params,{headers:headers})
}

function cardReaderList(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CARD_READER_LIST, params,{headers:headers})
}

function cardReaderDelete(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CARD_READER_DELETE, params,{headers:headers})
}

function paymentIntents(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CARD_READER_PAYMENTINTENTS, params,{headers:headers})
}


function paymentIntentsCapture(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.PAYMENTINTENT_CAPTURE, params,{headers:headers})
}

function subscriptionGet(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.SUBSCRIPTION_GET, params,{headers:headers})
}

// The SALON's card-fee payer (what money reads); null when never chosen.
function getTransactionFee() {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.get(API.TRANSACTION_FEE, {headers:headers})
}

function updateTransactionFee(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.UPDATE_TRANSACTION_FEE, params,{headers:headers})
}

function createLoginLink(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CREATE_LOGIN_LINK, params,{headers:headers})
}

function cancelTerminalTransaction(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CANCEL_TERMINAL_TRANSACTION, params,{headers:headers})
}

function checkCardAdded(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CHECK_CARD_ADDED, params,{headers:headers})
}


function paymentMethodAdd(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.PAYMENT_METHOD_ADD, params,{headers:headers})
}

function cardRemove(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CARD_REMOVE, params,{headers:headers})
}

function cardMakePrimery(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.CARD_MAKE_PRIMERY, params,{headers:headers})
}


function setUpIntent() {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    //console.log("headers",headers);
    return axios.post(API.SETUP_PAYMENT_INTENT,{},{headers:headers})
}

function createPaymentLink(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.CREATE_PAYMENT_LINK, params, {headers: headers})
}

function checkPaymentLinkStatus(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.CHECK_PAYMENT_LINK_STATUS, params, {headers: headers})
}

function createKlarnaPaymentLink(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.CREATE_KLARNA_PAYMENT_LINK, params, {headers: headers})
}

function createClearpayPaymentLink(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.CREATE_CLEARPAY_PAYMENT_LINK, params, {headers: headers})
}

function sendPaymentLinkEmail(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    return axios.post(API.SEND_PAYMENT_LINK_EMAIL, params, {headers: headers})
}